export const getDeviceHeight = () => {
  let vh = window.innerHeight
  document.documentElement.style.setProperty('--vh', `${vh}px`)

  if (navigator.userAgent.toLowerCase().indexOf('mozilla') > -1) {
    setTimeout(() => {
      const inputs = document.querySelectorAll(
        '.overlay input[type=text], .overlay input[type=email], .overlay input[type=password], .overlay input[type=search], .overlay input[type=number], .overlay input[type=tel], .overlay textarea'
      )
      inputs.forEach((el) => {
        el.addEventListener('blur', () => {
          setTimeout(() => {
            vh = window.innerHeight
            document.documentElement.style.setProperty('--vh', `${vh}px`)
          }, 80)
        })
      })
    }, 300)
  }
}

export const isMobile = () => {
  return window.innerWidth <= 1023
}

let scrollPosition

export const openModalHelper = () => {
  getDeviceHeight()
  window.addEventListener('resize', getDeviceHeight)
  scrollPosition = window.pageYOffset
  document.body.classList.add('lock-body')
  document.body.style.top = `-${scrollPosition}px`
}

export const closeModalHelper = () => {
  document.body.classList.remove('lock-body')
  document.body.style.top = `unset`
  window.scrollTo(0, scrollPosition)
  window.removeEventListener('resize', getDeviceHeight)
}

export const initVhSizes = () => {
  getDeviceHeight()
}

export const toggleElement = element => {
  element.classList.toggle('opened')
}
